import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { Accordion, AccordionSummary, Typography } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react/dist/ssr";

import { STALE_TIME_1_MINUTES } from "@constants/reactQueryKeys";
import { PeopleFilter } from "@answersnow/pkg-theme";
import { searchUsers } from "api/users";
import { useGetUserById } from "hooks/api/user/useGetUserById";

export const PeopleFiltering = ({
  canSearchAll,
  inputValue,
  userId,
  filteredPeople,
  setInputValue,
  filterByURL,
  setFilteredPeople,
  colorIndexManager,
  singlePick,
  label,
  getOptionLabel,
  isInModal,
}) => {
  // If there is a filter by URL, use the userId from the URL to get the user
  const { user } = useGetUserById(filterByURL?.userId);

  const isEnabledToSearch = Boolean(inputValue) && Boolean(userId) && !filterByURL?.userId;

  const { data: searchResponse } = useQuery(
    ["searchUsers", inputValue],
    () => searchUsers(userId, { nameInput: inputValue }),
    {
      enabled: isEnabledToSearch,
      cacheTime: 0, // Prevent caching
      staleTime: STALE_TIME_1_MINUTES, // Always consider data stale
    }
  );

  useEffect(() => {
    if (filteredPeople.length > 0) {
      setInputValue("");
    }
  }, [filteredPeople, setInputValue]);

  const searchResults = user ? [user] : searchResponse?.data ?? [];

  return (
    <Accordion
      defaultExpanded
      square
      disableGutters
      sx={{
        "&::before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: 0,
        },
        boxShadow: "none",
      }}
    >
      <AccordionSummary expandIcon={<CaretDown size={20} />} sx={{ padding: 0 }}>
        <Typography>{canSearchAll ? "People" : "Clients"}</Typography>
      </AccordionSummary>
      <div style={{ paddingBottom: "16px", marginBottom: "8px" }}>
        <PeopleFilter
          searchResults={searchResults}
          filteredPeople={filteredPeople}
          setInputValue={setInputValue}
          inputValue={inputValue}
          setFilteredPeople={setFilteredPeople}
          colorIndexManager={colorIndexManager}
          singlePick={singlePick}
          label={label}
          getOptionLabel={getOptionLabel}
          isInModal={isInModal}
          userIdFromURL={filterByURL?.userId}
        />
      </div>
    </Accordion>
  );
};
